import React, { useEffect } from "react";
import jetblackBg from "../assets/images/jetblack-bg.png";

const NewFAQPage = () => {
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      /* Sección hero con imagen de fondo estética y mayor altura */
      .heroSection {
        position: relative;
        width: 100%;
        height: 450px; /* Aumentada la altura */
        background-image: url(${jetblackBg});
        background-size: cover;
        background-position: center;
        display: flex;
        align-items: center;
        padding-left: 30px; /* Más espacio a la izquierda */
      }
      
      .heroSection::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
      }
      
      /* Contenido del hero alineado a la izquierda con títulos resaltados */
      .heroContent {
        position: relative;
        z-index: 1;
        text-align: left;
        font-family: "Merriweather", serif;
        max-width: 80%;
      }
      
      .heroContent h1 {
        font-size: 3rem; /* Tamaño aumentado para el título */
        margin: 0;
        color: #ffffff;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
      }
      
      .heroContent p {
        font-size: 1.5rem; /* Tamaño aumentado para el subtítulo */
        margin: 15px 0 0;
        color: #ffffff;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
      }
      
      /* Contenedor FAQ con mayor espacio y apariencia clara */
      .faqContainer {
        padding: 50px;
        max-width: 1100px;
        margin: 30px auto;
        font-family: "Merriweather", serif;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
      }
      
      .faqMainTitle {
        color: #0d2b3e;
        text-align: center;
        font-size: 2.5rem; /* Título principal más grande */
        margin-bottom: 40px;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
      }
      
      .faqSection {
        margin-bottom: 30px;
      }
      
      .faqTitle {
        color: #0d2b3e;
        font-size: 1.8rem; /* Títulos de sección más resaltados */
        margin-bottom: 15px;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
      }
      
      .faqText {
        font-size: 1.1rem; /* Texto un poco más grande */
        line-height: 1.8;
        color: #333333;
      }
      
      .faqNote {
        font-size: 1rem;
        font-style: italic;
        color: #555555;
        text-align: center;
      }
      
      .highlight {
        color: #0d2b3e;
        font-weight: bold;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div>
      {/* Sección hero */}
      <div className="heroSection">
        <div className="heroContent">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to your questions below</p>
        </div>
      </div>

      {/* Contenedor del FAQ */}
      <div className="faqContainer">
        <h1 className="faqMainTitle">Frequently Asked Questions</h1>

        <section className="faqSection">
          <h2 className="faqTitle">Payment Method</h2>
          <p className="faqText">
            Payment Method is to be established prior to the trip. Jet Black Limousine currently accepts all major credit cards. Chauffeurs are not authorized to apply or discount charges. We do not charge trips until after they are completed, with the exception of specialty vehicle rentals which require a deposit prior to the event date.
          </p>
        </section>

        <section className="faqSection">
          <h2 className="faqTitle">Additional Charges</h2>
          <p className="faqText">
            - Extra stop fees (Sedan): In general, stops in the same town as the original pickup = $10.00, adjacent town and/or within 25 miles = $20.00, and more than 25 miles = $40.00.
            <br />
            - Stops at LGA enroute to JFK are $40.00. Stops in NYC enroute to LGA &amp; JFK are $50.00.
            <br />
            - Tolls: Varies depending on the original pickup location and destination.
            <br />
            - Parking: Varies depending on arrival airport and wait time.
            <br />
            - Holiday Fees:
            <br />
            &nbsp;&nbsp;&nbsp;1. Easter, Memorial Day, Labor Day, and Christmas Eve are subject to a $15.00 fee.
            <br />
            &nbsp;&nbsp;&nbsp;2. Independence Day, Thanksgiving, Christmas, New Year’s Eve and New Year’s Day are subject to a $25.00 fee.
          </p>
        </section>

        <section className="faqSection">
          <h2 className="faqTitle">Wait Time Policy</h2>
          <p className="faqText">
            The grace period is determined by the pick-up location and starts at the scheduled pickup time. If the grace period expires before contact is made with the client, waiting time will be charged in 15-minute increments from the originally scheduled pickup time.
            <br /><br />
            - Residential/Office Pickups: 15-minute wait time allowed from the originally scheduled pickup time.
            <br />
            - Domestic Arrivals: 45-minute wait time allowed after flight landing.
            <br />
            - International Arrivals: 60-minute wait time allowed after flight landing.
            <br />
            - FBO Pickups: 30-minute wait time allowed after flight landing.
            <br />
            - Flight Diversions: 60 minutes wait time allowed after landing at a diverted airport.
          </p>
        </section>

        <section className="faqSection">
          <h2 className="faqTitle">Cancellation Policy &amp; Changes</h2>
          <p className="faqText">
            To avoid a cancellation fee, we require at least 4 hours' notice for local travel, 8 hours' notice for out-of-town reservations, and 24 hours' notice for international reservations.
          </p>
        </section>

        <section className="faqSection">
          <h2 className="faqTitle">Diverted Flights</h2>
          <p className="faqText">
            If your flight is diverted to another airport, you have 60 minutes grace to contact us from the time the flight lands at the diverted airport. You must inform us of your plans—whether you want us to release the scheduled vehicle, keep the driver reserved until you return to the original arrival airport, or re-book the reservation for another time if your delay is not extended. If you decide to release the driver, you will be charged the full rate of your reservation. However, if you release the driver and choose to make a new reservation within 12 hours, you will receive a <span className="highlight">50% discount</span> off the base rate for that trip. If you choose to have the driver wait for you to return to the original arrival airport, you agree to pay waiting time from the end of the grace period until your plane arrives back.
          </p>
        </section>

        <section className="faqSection">
          <h2 className="faqTitle">Lost or Misplaced Items</h2>
          <p className="faqText">
            Neither Jet Black Limo nor its employees shall be held responsible for items left in vehicles by any passengers. In the event that items are recovered after trips are taken, we will make every effort to return them to their proper owner in a timely manner. Any items found in vehicles are retained by us for 30 days. Please contact our office to arrange for retrieving any lost property.
          </p>
        </section>

        <section className="faqSection">
          <h2 className="faqTitle">Rate Estimate</h2>
          <p className="faqText">
            Rates quoted prior to service are an initial estimate of the cost of services reserved. Additional changes to the original service(s) may result in a change in the final fare.
          </p>
        </section>

        <section className="faqSection">
          <h2 className="faqTitle">Passenger Conduct</h2>
          <p className="faqText">
            No alcohol may be consumed by anyone under the age of 21 in this vehicle. For safety reasons, the consumption or possession of <span className="highlight">illegal substances, including controlled substances</span>, is strictly prohibited on board. Violation of this policy is grounds for immediate termination of transportation without refund.
            <br /><br />
            Passengers assume full responsibility for any damage caused to the vehicle during the rental. Any damage exceeding normal wear and tear will be subject to fees based on the actual cost of repair, replacement, or cleaning. The driver reserves the right to terminate any trip if passenger or chauffeur safety is at risk or if there is reason to believe that <span className="highlight">illegal activity</span> is taking place in the vehicle. Please note that the legal consumption of alcohol varies by vehicle.
          </p>
        </section>

        <section className="faqSection">
          <p className="faqNote">
            *All special event change and cancellation policies supersede standard policies and are noted in the specific email confirmation.
          </p>
        </section>
      </div>
    </div>
  );
};

export default NewFAQPage;
